import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ImageGalleryBlock1 as Block } from "./ImageGalleryBlock1";
import { defaultData } from "./ImageGalleryBlock1DefaultData";
import { meta } from "./ImageGalleryBlock1Metadata";
import previewImage from "./image_gallery_block_1_preview.png";

export const ImageGalleryBlock1: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: previewImage,
  },
  defaultData,
  meta,
};
